/*
 *
 * OperationSecurityWarnings
 *
 * @version 1.0.0
 * @author Stefano Servodidio
 * @since 01-Jul-2024
 */
import React from 'react'
import PortalMessage from 'Hoc/PortalMessage'

const formattedMessage = {
  SecurityCode: <PortalMessage id='t.app.orders.operation.security.code' defaultMessage='Code' />,
  Securitydescription: <PortalMessage id='t.app.orders.operation.security.description' defaultMessage='Description' />,
  emptyList: <PortalMessage id='t.app.orders.emptyList' defaultMessage='No data available' />
}

export default formattedMessage
